import React, { useEffect, useState } from "react";
import { Sentinel } from "../../model_gen/sentinel";
import SentinelForm from "./SentinelForm";
import { Skeleton } from "../ui/skeleton";

interface EditSentinelFormProps {
  sentinel: Sentinel | undefined;
  loading: boolean;
  setLoading?: (loading: boolean) => void;
  isDataLoaded: boolean;
  onSubmit: (formData: any) => void;
  onClose: () => void;
  readOnly?: boolean;
  regenerationEnabled?: boolean;
}

const EditSentinelForm: React.FC<EditSentinelFormProps> = ({
  sentinel,
  loading,
  setLoading,
  isDataLoaded,
  onSubmit,
  onClose,
  readOnly = false,
  regenerationEnabled = false,
}) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    // Force re-render of SentinelForm when sentinel changes
    setKey(prevKey => prevKey + 1);
  }, [sentinel]);

  if (!isDataLoaded) {
    return (
      <div className="space-y-6">
        {/* Name field skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        
        {/* Severity field skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-48" />
        </div>
        
        {/* Collapsible sections skeleton */}
        {[...Array(3)].map((_, i) => (
          <div key={i} className="border border-border rounded-lg">
            <div className="p-4 border-b border-border">
              <Skeleton className="h-5 w-32" />
            </div>
            <div className="p-4 space-y-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-24 w-full" />
              </div>
            </div>
          </div>
        ))}
        
        {/* Include options skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-32" />
          <div className="grid grid-cols-2 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="flex items-center gap-2">
                <Skeleton className="h-6 w-12 rounded-full" />
                <Skeleton className="h-4 w-24" />
              </div>
            ))}
          </div>
        </div>
        
        {/* Action buttons skeleton */}
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-32" />
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-20" />
        </div>
      </div>
    );
  }

  return (
    <SentinelForm
      key={key}
      initialSentinel={sentinel}
      loading={loading}
      setLoading={setLoading}
      onSubmit={onSubmit}
      onClose={onClose}
      submitButtonText="Update Sentinel"
      readOnly={readOnly}
      regenerationEnabled={regenerationEnabled}
    />
  );
};

export default EditSentinelForm;
